/**
 * Logger utility for frontend
 * Only logs in development mode, silent in production
 */

const isDev = import.meta.env.DEV

type LogLevel = 'log' | 'warn' | 'error' | 'debug' | 'info'

interface Logger {
  log: (...args: unknown[]) => void
  warn: (...args: unknown[]) => void
  error: (...args: unknown[]) => void
  debug: (...args: unknown[]) => void
  info: (...args: unknown[]) => void
}

const createLogger = (): Logger => {
  const logWithLevel = (level: LogLevel) => (...args: unknown[]) => {
    if (level === 'error') {
      // Always log errors
      console.error(...args)
    } else if (isDev) {
      // Only log other levels in development
      console[level](...args)
    }
  }

  return {
    log: logWithLevel('log'),
    warn: logWithLevel('warn'),
    error: logWithLevel('error'),
    debug: logWithLevel('debug'),
    info: logWithLevel('info'),
  }
}

export const logger = createLogger()

export default logger
